import { useEffect, useState } from 'react';
import s from './CompactToast.module.css';

const AUTO_DISMISS_MS = 4000;

export default function CompactToast({ progression, onDismiss }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onDismiss, 300);
    }, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  if (!progression) return null;

  const { xp_awarded, streak, level } = progression;
  const charsToNext = level.next_threshold ? level.next_threshold - level.known_count : null;

  return (
    <div className={`${s.toast} ${visible ? s.toastIn : s.toastOut}`} role="status" aria-live="polite">
      <div className={s.xpBadge}>
        <span className={s.xpNumber}>+{xp_awarded}</span>
        <span className={s.xpLabel}>XP</span>
      </div>
      <div className={s.info}>
        <span className={s.primaryLabel}>
          {progression.xp_breakdown?.[0]?.label || 'Nice work!'}
        </span>
        {streak?.updated && streak.current > 1 && (
          <span className={s.streakLine}>🔥 {streak.current}-day streak</span>
        )}
        {charsToNext !== null && charsToNext <= 10 && (
          <span className={s.nearLine}>{charsToNext} chars to {level.name}!</span>
        )}
      </div>
      <button type="button" className={s.close} onClick={() => { setVisible(false); setTimeout(onDismiss, 300); }} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}
